import React, { useState, useRef, useEffect } from 'react';

import song from '../audio/SongForTheUnificationOfEurope.mp3';

function AudioPlayer() {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef(new Audio(song));

  useEffect(() => {
    // Ensure the audio loops
    audioRef.current.loop = true;
  }, []);

  const togglePlay = () => {
    if (isPlaying) {
      audioRef.current.pause();
    } else {
      audioRef.current.play();
    }
    setIsPlaying(!isPlaying);
  };

  return (
    <button
      onClick={togglePlay}
      style={{
        position: 'fixed',
        bottom: '10px',
        right: '10px',
        padding: '10px',
        backgroundColor: 'transparent',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: 'pointer',
        fontSize: '24px',
      }}
    >
      {isPlaying ? '🔊' : '🔇'}
    </button>
  );
}

export default AudioPlayer; 